//#region src/dom/webkit.ts
/**
* Whether WebKit's AirPlay APIs are present in this realm (Safari macOS/iOS).
*
* @internal
*/
function supportsWebKitAirPlay() {
	return "WebKitPlaybackTargetAvailabilityEvent" in globalThis;
}
/**
* Whether `media` exposes WebKit's AirPlay APIs.
*
* @internal
*/
function isWebKitAirPlayCapable(media) {
	return supportsWebKitAirPlay() && "webkitCurrentPlaybackTargetIsWireless" in media;
}
//#endregion
export { isWebKitAirPlayCapable, supportsWebKitAirPlay };

//# sourceMappingURL=webkit.js.map